const notice = [{
  desc: '查询首页通知内 公告和更新日志接口',
  options: {
    url: '/notice/getNoticeForIndex',
    method: 'post'
  },
  vuex: false
}, {
  desc: '查询首页通知内 公告和更新日志未读数据接口',
  options: {
    url: '/notice/getUnreadNoticeForIndexCount',
    method: 'post'
  }
}, {
  desc: '设置公告已读',
  options: {
    url: '/notice/AddNoticeDetail',
    method: 'post'
  }
}, {
  desc: '核保政策公告',
  options: {
    url: '/notice/UnderwritingPolicyNotices',
    method: 'post'
  }
}, {
  desc: '是否显示二维码',
  options: {
    url: '/notice/getNotBindNotice',
    method: 'get'
  }
}]
export default notice



// WEBPACK FOOTER //
// ./src/api/notice.js